import React from "react";
import { Button, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import comingSoon from "../../../images/comingSoon.png";
import Slide from "react-reveal/Slide";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import bg from "../../../images/banner.png";

const Blog = () => {
  const banner = {
    background: `url(${bg})`,
    backgroundColor: "#f5f5f590",
    backgroundBlendMode: "lighten, luminosity",
    height: "100vh",
    backgroundRepeat: "no-repeat",
    marginBottom:"100px"
  };
  const title = {
    fontFamily: "'Satisfy', cursive",
    color: "#033d44",
  };
  return (
    <Container
      style={banner}
      className="d-flex flex-column align-items-center  align-items-lg-end justify-content-center"
    >
      <Slide left>
        <h1 className="display-1 fw-bold ps-2 mt-5" style={title}>
          My Blogs
        </h1>
      </Slide>
      <img src={comingSoon} className="w-25" alt="" />
      <Button variant="outline-dark" className="me-lg-5">
        <FontAwesomeIcon
          style={{
            color: "#033d44",
            fontWeight: "bold",
            marginRight: "10px",
          }}
          icon={faHome}
        />
        <NavLink className="custom-btn" to={`/home`}>
          Home
        </NavLink>
      </Button>
    </Container>
  );
};

export default Blog;
